// extracted by mini-css-extract-plugin
export default {"Flex":"Flex_Flex__n0ltX"};